import React, { useEffect } from "react";
import { Button, Col, Form, Modal, Row } from "antd";
import { FormBox, InputBox } from "../../../../components/AntdAddons";
import { validations } from "../../../../config/validations/validations";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { AppDispatch } from "../../../../store/app";
import { useDispatch } from "react-redux";
import { updateEmails } from "../../../../store/SendMessageSlice";

const UpdateEmailModal: React.FC<any> = (props) => {
  const { visible, updateEmailData, getList, close } = props;

  const dispatch: AppDispatch = useDispatch();
  const [form] = Form.useForm();
  

  useEffect(() => {
    if (updateEmailData) {
      // form.setFieldValue("request_id", updateEmailData?.request_id);
      form.setFieldsValue({
        request_id: updateEmailData?.request_id,
        email: updateEmailData?.email,
      });
    }
  }, [updateEmailData, form]);

  const handleSubmit = (data: any) => {
    dispatch(updateEmails(data))
      .then(() => {
        close();
        getList();
        form.resetFields();
      })
      .catch((e: any) => {
        console.warn(e);
      });
  };
  // for validation
  const handleChange = () => {
    form
      .validateFields()
      .then(() => {
        // setDisable(false);
      })
      .catch((error: any) => {
        // setDisable(true);
      });
  };

  return (
    <>
      <Modal
        open={visible}
        destroyOnClose
        width={800}
        onCancel={close}
        closeIcon={<FontAwesomeIcon icon={faTimes} />}
        footer={false}
        className="addModal"
        title={`Update Email`}
      >
        <FormBox
          className="filterForm"
          form={form}
          onFinish={handleSubmit}
          onChange={handleChange}
          validateTrigger={["onBlur", "onInput"]}
          autoComplete="off"
        >
          <Row gutter={20} align={"top"}>
            <Col xs={24} md={12}>
              <InputBox.Text
                label="Request ID"
                name={"request_id"}
                required
                rules={[
                  validations.required.text("Request ID"),
                  validations.pattern.whitespace,
                ]}
              />
            </Col>
            <Col xs={24} md={12}>
              <InputBox.Text
                name="email"
                label="Email"
                tooltip="Please enter comma separated valid email addresses."
                rules={[
                  validations.required.text("Email"),
                  validations.pattern.multiEmail("Email"),
                  validations.pattern.whitespace,
                ]}
              />
            </Col>
            <Col xs={12} md={12} lg={6}>
              <Button type="primary" htmlType="submit">
                Submit
              </Button>
            </Col>
          </Row>
        </FormBox>
      </Modal>
    </>
  );
};

export default UpdateEmailModal;
